import { Collapse } from '@mui/material';
import { Theme as AugmentedTheme, useTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Icon, Paper, Typography } from 'web-library';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { UseHoverReturn } from './menu/DesktopMenu';

import {typeTheme} from "web-library/theme/helper/tssHelper"
const useStyles = makeStyles()((theme) =>
({
  menuItem: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
  fullHeightItem: {
    flex: 1,
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  menuLabel: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    color: theme.color.text.textTertiary,
    userSelect: 'none',
    msUserSelect: 'none',
    MozUserSelect: 'none',
    WebkitUserSelect: 'none',
    // @ts-ignore
     ...typeTheme(theme, 'body1bold'),
  },
  menuActiveLabel: {
    color: theme.color.text.textHeader,
  },
  edgeAnchor: {
    position: 'relative',
  },
  menuPaper: {
    zIndex: 999,
    position: 'absolute',
    width: 250,
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: theme.color.background.bgInverse01,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: theme.spacing(2),
    borderBottomRightRadius: theme.spacing(2),
    boxShadow: theme.shadow.shadow3,
    [theme.breakpoints.down('lg')]: {
      marginTop: theme.spacing(2),
    },
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(0),
    },
  },
  subMenuItemGroupLabelContainer: {
    color: theme.color.text.textContrast,
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: theme.color.border.borderInverse,
  },
  subMenuItemNoLabel: {
    color: theme.color.text.textContrast,
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    borderTopWidth: 1,
    borderTopStyle: 'solid',
    borderTopColor: theme.color.border.borderInverse,
  },
  nonNationExamItem: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    color: theme.color.text.textInactive,
    '&:hover': {
      color: theme.color.text.textContrast,
      backgroundColor: 'rgba(232, 232, 232, 0.3)',
    },
  },
  subMenuItem: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    color: theme.color.text.textInactive,
    '&:hover': {
      color: theme.color.text.textContrast,
      backgroundColor: 'rgba(232, 232, 232, 0.3)',
    },
  },
  activeSubMenuItem: {
    color: theme.color.text.textContrast,
  },
  subMenuLabel: {
    fontWeight: 'normal',
    userSelect: 'none',
    msUserSelect: 'none',
    MozUserSelect: 'none',
    WebkitUserSelect: 'none',
  },
  menuItemIcon: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

interface MenuSubItemProps extends UseHoverReturn {
  idKey: string;
  label: string;
  isActiveMenu: boolean;
  subMap: (
    | {
      id?: string;
      idKey: string;
      label: string;
      navigate: () => void;
      isActiveSubMenu: boolean;
      isNonNationExam?: boolean;
    }
    | string
  )[];
}

export const MenuSubItem = ({
  anchorEl,
  handleHover,
  handleEndHoverClose,
  timerCancel,
  handleClose,
  idKey,
  label,
  subMap,
  isActiveMenu,
}: MenuSubItemProps) => {
  const { classes } = useStyles();
  const theme = useTheme();
  const location = useLocation();

  const activeStyle =
    location.pathname === '/' || isActiveMenu || anchorEl ? classes.menuActiveLabel : '';

  return (
    <Box className={classes.menuItem}>
      <Box className={classes.fullHeightItem}>
        <Typography
          // @ts-ignore
          id={`menu-${idKey}`}
          className={[classes.menuLabel, activeStyle].join(' ')}
          variant="subtitle1"
          onMouseOver={handleHover}
          onMouseLeave={handleEndHoverClose}
        >
          {label}
          <Icon
            size="S"
            className={classes.menuItemIcon}
            color={theme.color.icon.iconDefault}
            name={IconName.arrowDown}
          />
        </Typography>
      </Box>

      <div>
        <Box className={classes.edgeAnchor}>
          <Paper className={classes.menuPaper} onMouseOver={timerCancel} onMouseLeave={handleClose}>
            <Collapse in={Boolean(anchorEl)}>
              {subMap.map((item, index) => {
                if (typeof item === 'string') {
                  if (item === '') {
                    return (
                      <Box
                        id={`menu-${idKey}-submenu-${item}`}
                        key={item}
                        className={classes.subMenuItemNoLabel}
                      />
                    );
                  }
                  return (
                    <Box
                      id={`menu-${idKey}-submenu-${item}`}
                      key={item}
                      className={classes.subMenuItemGroupLabelContainer}
                    >
                      <Typography variant="h5">{item}</Typography>
                    </Box>
                  );
                }

                const activeSubMenuStyle = item.isActiveSubMenu ? classes.activeSubMenuItem : '';
                const nonNationExamStyle = item.isNonNationExam
                  ? classes.nonNationExamItem
                  : classes.subMenuItem;
                return (
                  <Box
                    id={`menu-${idKey}-submenu-${item.idKey}`}
                    // eslint-disable-next-line react/no-array-index-key
                    key={item.idKey || item.label}
                    className={[activeSubMenuStyle, nonNationExamStyle].join(' ')}
                    onClick={() => {
                      item.navigate();
                      handleClose();
                    }}
                  >
                    <Typography variant="caption" className={classes.subMenuLabel}>
                      {item.label}
                    </Typography>
                  </Box>
                );
              })}
            </Collapse>
          </Paper>
        </Box>
      </div>
    </Box>
  );
};

export default MenuSubItem;
